<template>
	<div class="login">
		<p class="time">当前时间：{{ nowDate }}</p>
		<div class="main">
			<h1>{{ examination_name }}</h1>
			<el-form size="large" :model="form" :rules="rules" label-width="100px" ref="formRef" hide-required-asterisk>
				<el-form-item label="真实姓名" prop="name"><el-input placeholder="请输入真实姓名" v-model="form.name"></el-input></el-form-item>
				<!--<el-form-item label="证件类型" prop="type">
					<el-select v-model="form.type" placeholder="请选择">
						<el-option v-for="item in type_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="证件号码" prop="card_id"><el-input placeholder="请输入证件号码" v-model="form.card_id"></el-input></el-form-item> -->
				<el-form-item label="手机号" prop="id"><el-input placeholder="请输入手机号" v-model="form.id"></el-input></el-form-item>
				<el-form-item label="校验码" prop="verification">
					<div class="flex">
						<el-input v-model="form.verification" placeholder="请输入校验码"></el-input>
						<img ref="verification" @click="getIdentity()" />
					</div>
				</el-form-item>
				<el-form-item label=" ">
					<el-button round size="large" type="primary" style="width: 220px;" @click="onSubmit()">登 录</el-button>
					<!-- <el-button plain size="large" type="danger" @click="handleRetrieve()">找回报名序号</el-button> -->
				</el-form-item>
			</el-form>
			<div class="instruction" style="font-size:24px">
				<p>提示：<span style="color: #1a222e">推荐使用</span>360浏览器、QQ浏览器、谷歌浏览器、搜狗浏览器</p><br>
				<p>请务必使用浏览器的<span style="font-weight: bold">极速模式</span>访问本系统</p>
			</div>
		</div>
		<!-- 找回报名序号 -->
		<retrieve-dialog ref="retrieve-dialog"></retrieve-dialog>
		<div class="copyright"><a style="text-decoration: none; color:black" target="_blank" href="https://beian.miit.gov.cn/ ">渝ICP备2024041183号-1</a></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { validateCardID } from '@/tools/validate';
import { MessageBox } from 'element-ui';
import RetrieveDialog from './components/RetrieveDialog';
import { reqGetIdentity, reqGetVerification, reqLogin } from '@/api';
export default {
	components: {
		RetrieveDialog
	},
	data() {
		return {
			nowDate: '', // 当前日期
			ctr: true,
			form: {
				type: '身份证'
			},
			rules: {
				name: [
					{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}
				],
				card_id: [
					{
						validator: validateCardID,
						trigger: 'blur'
					},
					{
						required: true,
						message: '请输入证件号码',
						trigger: 'blur'
					}
				],
				id: [
					{
						required: true,
						message: '请输入报名序号',
						trigger: 'blur'
					}
				],
				verification: [
					{
						required: true,
						message: '请输入校验码',
						trigger: 'blur'
					}
				]
			},
			type_options: [
				{
					label: '身份证',
					value: '身份证'
				}
			],
			url: ''
		};
	},
	computed: {
		...mapState({
			unitName: state => state.system.unitName,
			unitId: state => state.system.unitId,
			refresh: state => state.system.refresh,
			company_id: state => state.system.examInfo.company_id,
			examination_id: state => state.system.examInfo.examination_id,
			examination_name: state => state.system.examInfo.examination_name
		}),
		unit() {
			return this.$route.query.unit;
		}
	},
	mounted() {
		this.currentTime();
		this.getIdentity();
	},
	// 销毁定时器
	beforeDestroy() {
		if (this.formatDate) {
			clearInterval(this.formatDate); // 在Vue实例销毁前，清除时间定时器
		}
	},
	methods: {
		// 获取登录身份标识
		getIdentity() {
			reqGetIdentity().then(res => {
				this.form = {
					...this.form,
					identity: res.data
				};
				this.getVerification(res.data, res.msg);
			});
		},
		// 获取验证码
		getVerification(identity, unit_id) {
			this.$refs.verification.src = `${
				process.env.NODE_ENV === 'development' ? 'http://localhost:11999' : location.origin
			}/index.php/get_verification?identity=${identity}&unit_id=${unit_id}`;
		},
		currentTime() {
			setInterval(this.formatDate, 500);
		},
		formatDate() {
			let date = new Date();
			let year = date.getFullYear(); // 年
			let month = date.getMonth() + 1; // 月
			month = month < 10 ? '0' + month : month;
			let day = date.getDate(); // 日
			day = day < 10 ? '0' + day : day;
			let week = date.getDay(); // 星期
			let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
			let hour = date.getHours(); // 时
			hour = hour < 10 ? '0' + hour : hour; // 如果只有一位，则前面补零
			let minute = date.getMinutes(); // 分
			minute = minute < 10 ? '0' + minute : minute; // 如果只有一位，则前面补零
			let second = date.getSeconds(); // 秒
			second = second < 10 ? '0' + second : second; // 如果只有一位，则前面补零
			this.nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
		},
		// 登录
		onSubmit() {
			this.$refs['formRef'].validate(valid => {
				if (valid && this.ctr) {
					this.ctr = false;
					reqLogin({
						...this.form,
						company_id: this.company_id,
						examination_id: this.examination_id
					})
						.then(res => {
							if (!isNaN(res.data)) {
								setTimeout(() => {
									this.ctr = true;;
								},10000);
								MessageBox.alert('当前登陆人数较多，请10分钟后尝试刷新登录！！！', '温馨提示', {
									confirmButtonText: '确定',
									callback: action => {
										this.$message({
											type: 'info',
											message: `请稍后！！！`
										});
									}
								});
								return;
							}
							let time_out = new Date().getTime()/1000 + 60 * 8;
							this.$store.commit('system/SET_TIME_OUT', time_out);
							this.$store.commit('user/SET_EXAMINEE', {
								...res.data,
								serial_id: this.form.id
							});
							this.$store.commit('system/SET_PAY_MENT', res.data.payment);
							this.$message.success(res.msg);
							this.$store.dispatch('user/resetUserInfo');
							this.$store.commit('user/SET_ADD_FORM_NUM', 0);
							setTimeout(() => {
								this.ctr = true;
								this.$router.push({path: '/form'});
							},1000)
						})
						.catch(() => {
							this.ctr = true;;
							this.getIdentity();
						});
				} else {
					return false;
				}
			});
		},
		// 找回报名序号
		handleRetrieve() {
			this.$refs['retrieve-dialog'].dialogVisible = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.copyright {
	position: fixed;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 14px;
}
.login {
	width: 100vw;
	height: 100vh;
	position: relative;

	.time {
		position: absolute;
		top: 7%;
		right: 5%;
		font-size: 14px;
		color: #1a222e;
	}

	.main {
		position: absolute;
		top: 15%;
		left: 10%;
		display: flex;
		flex-direction: column;
		margin-left: 20%;

		h1 {
			width: 600px;
			text-align: center;
			line-height: 1.5;
			font-size: 38px;
			color: #1a222e;
			font-weight: 500;
		}

		

			.instruction {
				padding-top: 15px;
				display: flex;
				align-items: center;
				overflow-x: hidden;
				overflow-y: auto;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 50px 0;
					
				> p {
					color:#FF0000;
				}
			}

		.el-form {
			width: 500px;
			.el-form-item {
				margin-bottom: 30px;

				.flex {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.el-input {
						margin-right: 15px;
						width: 265px;
					}

					> img {
						flex-shrink: 0;
						cursor: pointer;
					}
				}
			}
		}
	}
}
</style>
